import { heroImage } from '../../mock';

export const HeroBackdrop = ({ scrollY }) => (
  <>
    <div className="absolute inset-0 will-change-transform" style={{ transform: `translate3d(0, ${scrollY * 0.35}px, 0) scale(${1 + scrollY * 0.0004})` }}>
      <img src={heroImage} alt="Membran yapi" className="w-full h-full object-cover kenburns" loading="eager" />
      <div className="absolute inset-0 bg-gradient-to-b from-background/40 via-background/30 to-background/90" />
      <div className="absolute inset-0 bg-gradient-to-r from-background/70 via-transparent to-transparent" />
    </div>
    <div className="pointer-events-none absolute inset-0 z-[1] transition-opacity duration-500 hidden md:block" style={{ background: 'radial-gradient(560px circle at var(--x) var(--y), hsl(var(--primary) / 0.10), transparent 60%)' }} />
  </>
);